/* eslint-disable import/no-cycle */
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  CityProps,
  CountryProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { FilterModel } from "../../../../../domain/models/enum";
import { TakerModel } from "../../../../../domain/models/taker";
import { ViaCepResponse } from "../../../../../domain/models/via-cep";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import ButtonComponent from "../../../../components/button";
import ButtonRound from "../../../../components/button-action";
import { ItemField } from "../../../../components/datagrid";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import Icons from "../../../../components/icons-helper";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "./styles";
import TomadorComponent from "../../issue/form/tomador";
import { NationalServiceModel } from "../../../../../domain/models/national-service";
import { NbsModel } from "../../../../../domain/models/nbs";
import { makeRemoteNationalService } from "../../../../../main/factories/usecases/national-service/remote-national-service-factory";
import { makeRemoteNbs } from "../../../../../main/factories/usecases/nbs/remote-nbs-factory";
import { makeRemoteIss } from "../../../../../main/factories/usecases/iss/remote-iss-factory";
import { getIssAliquot } from "../../issue/form/utils/iss";
import { formatNationalTaxCode } from "../../../../../utils/tax";
import { GoodsMovementTypeList } from "../../../../enums/goods-movement-type.enum";
import { MDICTypeList } from "../../../../enums/mdic-type.enum";
import HelperMask from "../../../../helpers/helper-mask";
import {
  EnforceabilityEnum,
  EnforceabilityList,
  ENFORCEABILITY_ZERO_ISS,
} from "../../../../enums/enforceability.enum";
import { ServiceProvisionModeList } from "../../../../enums/service-provision-mode.enum";
import { ServiceProvisionLinkList } from "../../../../enums/service-provision-link.enum";
import { PromotionTypeModel } from "../../../../../domain/models/promotion-type";
import { makeRemoteProviderPromotionType } from "../../../../../main/factories/usecases/promotion-type/remote-provider-promotion-type-factory";
import { makeRemoteClientPromotionType } from "../../../../../main/factories/usecases/promotion-type/remote-client-promotion-type-factory";
import { showErrorMessage } from "../../../../helpers/helper-toast";

export const FilterFields = (setParams: any): GroupProp[] => {
  const [values, setValues] = useState<string>("");
  return [
    {
      groupName: "FILTER",
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Nome:",
          onChange: (e) => {
            setValues(e);
          },
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorSearch",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Pesquisar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({
                    ...prev,
                    filters: `socialReason~${values}`,
                  }))
                }
              />
            </div>
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorClear",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Limpar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({ ...prev, filters: null }))
                }
              />
            </div>
          ),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};
export const Fields = (
  developerCompaniesList: DeveloperCompanyModel[],
  currentNote: any,
  setCurrentNote: any,
): GroupProp[] => {
  const [companySelected, setCompanySelected] = useState<number>();
  const [aliquotIssRequired, setAliquotIssRequired] = useState<boolean>();
  const [iss, setIss] = useState<boolean>(false);

  const [nationalServices, setNationalServices] = useState<NationalServiceModel[]>([]);
  const [loadingNationalServices, setLoadingNationalServices] = useState<boolean>(false);
  const [nbsList, setNbsList] = useState<NbsModel[]>([]);
  const [loadingNbs, setLoadingNbs] = useState<boolean>(false);
  const [fetchedAliquot, setFetchedAliquot] = useState<string>("0");

  const [enforceability, setEnforceability] = useState<number>(
    currentNote?.enforceability || EnforceabilityEnum.EXPORTACAO,
  );
  const [providerPromotionTypes, setProviderPromotionTypes] = useState<PromotionTypeModel[]>([]);
  const [clientPromotionTypes, setClientPromotionTypes] = useState<PromotionTypeModel[]>([]);

  const issAutoZero = ENFORCEABILITY_ZERO_ISS.includes(enforceability);

  const selectedCompany = developerCompaniesList.find(
    (item) => item.id === companySelected,
  );

  const loadNationalServices = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNationalServices(true);
        const response = await makeRemoteNationalService().loadByCnae(initial);
        setNationalServices(response);
      } catch (error) {
        setNationalServices([]);
      } finally {
        setLoadingNationalServices(false);
      }
    })();
  };

  const loadNbs = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNbs(true);
        const response = await makeRemoteNbs().loadByLc116(initial);
        setNbsList(response);
      } catch (error) {
        setNbsList([]);
      } finally {
        setLoadingNbs(false);
      }
    })();
  };

  const loadIssCalculate = (nationalServiceId: number): void => {
    (async () => {
      if (!selectedCompany?.company?.id || !nationalServiceId) return;
      try {
        const response = await makeRemoteIss().calculate(selectedCompany.company.id, nationalServiceId);
        setFetchedAliquot(response.aliquot.toString().replace(".", ","));
      } catch (error) {
        setFetchedAliquot("0");
      }
    })();
  };

  useEffect(() => {
    if (currentNote?.company) {
      setCompanySelected(currentNote.company);
      const comp = developerCompaniesList.find((c) => c.id === currentNote.company);
      if (comp) {
        setAliquotIssRequired(comp.company?.simpleNacional);
      }
    }
    if (currentNote?.cnae) {
      loadNationalServices(currentNote.cnae);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNote?.company, currentNote?.cnae, developerCompaniesList.length]);

  useEffect(() => {
    if (currentNote?.nationalService && nationalServices.length > 0) {
      const ns = nationalServices.find((n) => n.id === currentNote.nationalService);
      if (ns) {
        loadNbs(ns.complementaryLawId);
        loadIssCalculate(currentNote.nationalService);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalServices.length, currentNote?.nationalService, selectedCompany?.id]);

  useEffect(() => {
    (async () => {
      try {
        const [providers, clients] = await Promise.all([
          makeRemoteProviderPromotionType().list(),
          makeRemoteClientPromotionType().list(),
        ]);
        setProviderPromotionTypes(providers || []);
        setClientPromotionTypes(clients || []);
      } catch (error) {
        setProviderPromotionTypes([]);
        setClientPromotionTypes([]);
      }
    })();
  }, []);

  useEffect(() => {
    if (issAutoZero) {
      setIss(false);
      setCurrentNote((prev: any) => ({ ...prev, iss: "false", issAliquot: "0" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issAutoZero]);

  return [
    {
      groupName: "Prestador",
      groupLabel: "Prestador:",
      items: [
        {
          name: "company",
          type: "select",
          validations: "inputRequired",
          label: "Selecione a empresa que prestou o serviço*:",
          filter: true,
          initialValue: currentNote?.company,
          onChange: (e: any) => {
            setCompanySelected(e.value);
            setCurrentNote((prev: any) => ({ ...prev, company: e.value }));
            const selected = developerCompaniesList.find(
              (item) => item.id === e.value,
            );
            const certificate = selected?.company?.certificate;
            if (selected && !(certificate?.id || certificate?.url)) {
              showErrorMessage(
                "Esta empresa não possui certificado digital cadastrado. Não é possível emitir nota fiscal sem um certificado digital. Você pode adicioná-lo ao editar o perfil da empresa.",
              );
            }
          },
          options: developerCompaniesList?.map((el) => ({
            value: el?.id,
            label: `${HelperMask.applyCnpjMask(el.company?.subscriptionNumber || "")} — ${el.company?.socialReason}`,
            rawCnpj: (el.company?.subscriptionNumber || "").replace(/\D/g, ""),
          })),
          filterBy: "label,rawCnpj",
          col: { xs: 12, md: 12, lg: 12 },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador (Estrangeiro):",
      items: [
        {
          name: "tomador",
          type: "component",
          component: (): JSX.Element => (
            <TomadorComponent
              setCurrentNote={setCurrentNote}
              currentNote={currentNote}
              selectedDeveloperId={selectedCompany?.developer?.id}
              lockForeign
            />
          ),
        },
      ],
    },
    {
      groupName: "ISSUE",
      groupLabel: "Dados da nota fiscal:",
      items: [
        {
          name: "competencia",
          type: "date",
          label: "Competência*: ",
          initialValue: currentNote?.competencia,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, competencia: val }));
          },
          validations: "inputRequired",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "emissionDate",
          type: "text",
          label: "Data de Emissão:",
          disabled: true,
          defaultValue: new Date().toLocaleDateString(),
          col: { xs: 4, md: 4, lg: 4 },
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Dados do Serviço:",
      items: [
        {
          name: "description",
          type: "textarea",
          label: "Discriminação do(s) serviço(s) prestado(s)*:",
          initialValue: currentNote?.description,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, description: val }));
          },
          validations: "inputRequired",
          rows: 6,
          col: { xs: 12, md: 12, lg: 12 },
        },
        {
          name: "cnae",
          type: "select",
          label: "Atividade Econômica do Prestador(CNAE)*:",
          tooltip: "As atividades listadas baseiam-se no seu CNPJ. Caso a lista esteja incompleta, você pode atualizá-la em seu perfil recarregando os dados da empresa.",
          needsTooltip: true,
          validations: "inputRequired",
          placeholder: "00000 - Exemplo",
          initialValue: currentNote?.cnae?.id || currentNote?.cnae,
          onChange: (e: any) => {
            const selected = selectedCompany?.company?.cnaes?.find((el) => el.id === e.value);
            setCurrentNote((prev: any) => ({
              ...prev,
              cnae: e.value,
              nationalService: undefined,
              nbs: undefined,
              cnaeLabel: selected ? `${selected.codeFormatted} - ${selected.description}` : "",
            }));
          },
          filter: true,
          options: selectedCompany?.company?.cnaes?.map((el) => ({
            ...el,
            value: el?.id,
            label: `${el?.codeFormatted} - ${el.description}`,
          })),
          col: { xs: 12, md: 12, lg: 12 },
        },
        {
          name: "nationalService",
          type: "select",
          label: "Serviço Nacional*:",
          placeholder: "Selecione o serviço nacional",
          initialValue: currentNote?.nationalService?.id || currentNote?.nationalService,
          loading: loadingNationalServices,
          disabled: loadingNationalServices,
          onChange: (e: any) => {
            const selected = nationalServices.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nationalService: e.value,
                nbs: undefined,
                nationalServiceLabel: `${formatNationalTaxCode(selected.nationalTaxCode)} - ${selected.description}`,
              }));
            }
          },
          options: nationalServices.map((el) => ({
            value: el?.id,
            label: `${formatNationalTaxCode(el?.nationalTaxCode)} - ${el?.description}`,
          })),
          filter: true,
          validations: "inputRequired",
          col: { xs: 12, md: 12, lg: 12 },
        },
        {
          name: "nbs",
          type: "select",
          label: "NBS*:",
          placeholder: "Selecione o NBS",
          initialValue: currentNote?.nbs?.id || currentNote?.nbs,
          loading: loadingNbs,
          disabled: loadingNbs,
          options: nbsList.map((el) => ({
            value: el?.id,
            label: `${el?.codigoNbs} - ${el?.description}`,
          })),
          onChange: (e: any) => {
            const selected = nbsList.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nbs: e.value,
                nbsLabel: `${selected.codigoNbs} - ${selected.description}`,
              }));
            }
          },
          filter: true,
          validations: "inputRequired",
          col: { xs: 12, md: 12, lg: 12 },
        },
        {
          name: "enforceability",
          type: "select",
          label: "Exigibilidade do ISS*:",
          initialValue: enforceability,
          defaultValue: enforceability,
          options: EnforceabilityList,
          disabled: true,
          onChange: (e: any) => {
            setEnforceability(Number(e.value));
            setCurrentNote((prev: any) => ({
              ...prev,
              enforceability: Number(e.value),
            }));
          },
          validations: "inputRequired",
          col: { xs: 12, md: 12, lg: 12 },
        },
      ],
    },
    {
      groupName: "FOREIGN_SERVICE",
      groupLabel: "Dados do serviço exterior:",
      items: [
        {
          name: "serviceProvisionMode",
          type: "select",
          label: "Modo de prestação do serviço*:",
          initialValue: currentNote?.serviceProvisionMode,
          defaultValue: currentNote?.serviceProvisionMode,
          options: ServiceProvisionModeList,
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              serviceProvisionMode: e.value,
            }));
          },
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "serviceProvisionLink",
          type: "select",
          label: "Vínculo da prestação*:",
          initialValue: currentNote?.serviceProvisionLink,
          defaultValue: currentNote?.serviceProvisionLink,
          options: ServiceProvisionLinkList,
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              serviceProvisionLink: e.value,
            }));
          },
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "goodsMovementType",
          type: "select",
          label: "Tipo de movimentação de bens*:",
          initialValue: currentNote?.goodsMovementType,
          defaultValue: currentNote?.goodsMovementType,
          options: GoodsMovementTypeList,
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              goodsMovementType: e.value,
            }));
          },
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "mdicType",
          type: "select",
          label: "Tipo MDIC*:",
          initialValue: currentNote?.mdicType,
          defaultValue: currentNote?.mdicType,
          options: MDICTypeList,
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              mdicType: e.value,
            }));
          },
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "currencyType",
          type: "text",
          label: "Tipo de moeda* (ex: USD, EUR):",
          initialValue: currentNote?.currencyType,
          defaultValue: currentNote?.currencyType,
          placeholder: "USD",
          maxLength: 3,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              currencyType: (val || "").toUpperCase().slice(0, 3),
            }));
          },
          validations: "currencyCodeRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "foreignServiceValue",
          type: "currency",
          label: "Valor do serviço em moeda estrangeira*:",
          initialValue: currentNote?.foreignServiceValue,
          defaultValue: currentNote?.foreignServiceValue,
          placeholder: "0,00",
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              foreignServiceValue: val,
            }));
          },
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "providerPromotionType",
          type: "select",
          label: "Tipo de fomento do prestador*:",
          initialValue: (() => {
            const raw = currentNote?.providerPromotionType;
            if (!raw) return undefined;
            if (typeof raw === "object") return raw.id;
            return providerPromotionTypes.find((el) => el.description === raw)?.id;
          })(),
          defaultValue: (() => {
            const raw = currentNote?.providerPromotionType;
            if (!raw) return undefined;
            if (typeof raw === "object") return raw.id;
            return providerPromotionTypes.find((el) => el.description === raw)?.id;
          })(),
          options: providerPromotionTypes.map((el) => ({
            value: el?.id,
            label: el?.description,
          })),
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              providerPromotionType: { id: Number(e.value) },
            }));
          },
          filter: true,
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
        {
          name: "clientPromotionType",
          type: "select",
          label: "Tipo de fomento do tomador*:",
          initialValue: (() => {
            const raw = currentNote?.clientPromotionType;
            if (!raw) return undefined;
            if (typeof raw === "object") return raw.id;
            return clientPromotionTypes.find((el) => el.description === raw)?.id;
          })(),
          defaultValue: (() => {
            const raw = currentNote?.clientPromotionType;
            if (!raw) return undefined;
            if (typeof raw === "object") return raw.id;
            return clientPromotionTypes.find((el) => el.description === raw)?.id;
          })(),
          options: clientPromotionTypes.map((el) => ({
            value: el?.id,
            label: el?.description,
          })),
          onChange: (e: any) => {
            setCurrentNote((prev: any) => ({
              ...prev,
              clientPromotionType: { id: Number(e.value) },
            }));
          },
          filter: true,
          validations: "inputRequired",
          col: { xs: 6, md: 6, lg: 6 },
        },
      ],
    },
    {
      groupName: "VALUES",
      groupLabel: "Valores:",
      items: [
        {
          name: "serviceValue",
          type: "currency",
          label: "Valor do(s) serviço(s)*:",
          placeholder: "0,00",
          initialValue: currentNote?.serviceValue,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, serviceValue: val }));
          },
          validations: "inputRequired",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "unconditionalDiscount",
          type: "currency",
          label: "Desconto Incondicionado:",
          placeholder: "0,00",
          initialValue: currentNote?.unconditionalDiscount,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, unconditionalDiscount: val }));
          },
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "conditionedDiscount",
          type: "currency",
          label: "Desconto Condicionado:",
          placeholder: "0,00",
          initialValue: currentNote?.conditionedDiscount,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, conditionedDiscount: val }));
          },
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "dedution",
          type: "currency",
          disabled: true,
          label: "Valor das deduções*:",
          placeholder: "0,00",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "totalValue",
          type: "currency",
          disabled: true,
          label: "Valor da Nota:",
          placeholder: "0,00",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "iss",
          type: "radio",
          label: "ISS Retido*:",
          initialValue: issAutoZero ? "false" : currentNote?.iss || "false",
          disabled: issAutoZero,
          onChange(val) {
            const company = developerCompaniesList.find(
              (item) => item.id === companySelected,
            );
            setAliquotIssRequired(company?.company?.simpleNacional);
            setIss(val === "true");
            setCurrentNote((prev: any) => ({ ...prev, iss: val }));
          },
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "issAliquot",
          type: "currency",
          defaultValue: issAutoZero
            ? "0"
            : getIssAliquot(iss, fetchedAliquot, currentNote?.issAliquot || "0"),
          initialValue: (issAutoZero
            ? "0"
            : (getIssAliquot(iss, fetchedAliquot, currentNote?.issAliquot) as any)),
          disabled: issAutoZero || !iss,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, issAliquot: val }));
          },
          label: issAutoZero ? "Alíquota (zerada — exigibilidade exterior):" : "Alíquota:",
          placeholder: "0,00",
          validations: !issAutoZero && iss && aliquotIssRequired ? "inputRequired" : "",
          col: { xs: 4, md: 4, lg: 4 },
        },
        {
          name: "otherDeductions",
          type: "currency",
          label: "Outras deduções:",
          placeholder: "0,00",
          initialValue: currentNote?.otherDeductions,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, otherDeductions: val }));
          },
          col: { xs: 4, md: 4, lg: 4 },
        },
      ],
    },
  ];
};

type DocTypeProps = "CNPJ" | "CPF" | "NONE"

export const FieldsTomador = (
  data: TakerModel | null | undefined,
  lockForeign?: boolean,
): GroupProp[] => {
  const [addressByCep, setAddressByCep] = useState<ViaCepResponse | null>(null);
  const [docType, setDocType] = useState<DocTypeProps>("CPF");
  const [isForeign, setIsForeign] = useState<boolean>(
    lockForeign || !!data?.isForeignTaker,
  );
  const [hasNif, setHasNif] = useState<boolean>(
    data?.isForeignTaker ? !!data?.codeForeign : true,
  );
  const [countries, setCountries] = useState<CountryProps[]>([]);

  useEffect(() => {
    setIsForeign(lockForeign || !!data?.isForeignTaker);
    setHasNif(data?.isForeignTaker ? !!data?.codeForeign : true);
  }, [data?.id, data?.isForeignTaker, data?.codeForeign, lockForeign]);

  useEffect(() => {
    if (!isForeign) return;
    (async () => {
      try {
        const list = await makeRemoteAddresss().loadCountries();
        setCountries(list);
      } catch (error) {
        setCountries([]);
      }
    })();
  }, [isForeign]);

  const getDocValidation = (doc: DocTypeProps): string => {
    if (doc === "CPF") {
      return "cpfValidation";
    }
    if (doc === "CNPJ") {
      return "cnpjValidation";
    }
    return "";
  };

  const toggleField = {
    name: "isForeignTaker",
    type: "radio",
    label: "Tomador estrangeiro?*",
    defaultValue: `${!!data?.isForeignTaker}`,
    initialValue: `${!!data?.isForeignTaker}`,
    options: [
      { value: "true", label: "Sim" },
      { value: "false", label: "Não" },
    ],
    onChange: (val: string) => {
      setIsForeign(val === "true");
    },
    validations: "inputRequired",
    col: { xs: 12, md: 12, lg: 12 },
  };

  if (isForeign) {
    const foreignItems: any[] = [];
    if (!lockForeign) foreignItems.push(toggleField);
    foreignItems.push(
      {
        name: "socialReason",
        type: "text",
        label: "Razão Social/Nome*:",
        defaultValue: data?.socialReason,
        placeholder: "",
        validations: "inputRequired",
        col: { xs: 12, md: 12, lg: 12 },
      },
      {
        name: "hasNif",
        type: "radio",
        label: "Possui NIF?*",
        defaultValue: `${hasNif}`,
        initialValue: `${hasNif}`,
        options: [
          { value: "true", label: "Sim" },
          { value: "false", label: "Não" },
        ],
        onChange: (val: string) => {
          setHasNif(val === "true");
        },
        validations: "inputRequired",
        col: { xs: 12, md: 12, lg: 12 },
      },
      hasNif
        ? {
          name: "codeForeign",
          type: "text",
          label: "Código NIF*:",
          defaultValue: data?.codeForeign,
          validations: "inputRequired",
          col: { xs: 12, md: 12, lg: 12 },
        }
        : {
          name: "naoNif",
          type: "select",
          label: "Motivo da ausência do NIF*:",
          defaultValue: data?.naoNif,
          validations: "inputRequired",
          options: [
            { value: "NAO_INFORMADO_NA_NOTA_DE_ORIGEM", label: "Não informado na nota de origem" },
            { value: "DISPENSADO_DO_NIF", label: "Dispensado do NIF" },
            { value: "NAO_EXIGENCIA_NIF", label: "Não exigência de NIF" },
          ],
          col: { xs: 12, md: 12, lg: 12 },
        },
      {
        name: "codeCountry",
        type: "select",
        label: "País*:",
        validations: "inputRequired",
        defaultValue: data?.address?.codeCountry,
        initialValue: data?.address?.codeCountry,
        filter: true,
        options: countries.map((el) => ({
          value: el?.isoCode,
          label: el.name,
        })),
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "descriptionCity",
        type: "text",
        label: "Cidade*:",
        defaultValue: data?.address?.descriptionCity || data?.address?.name,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "state",
        type: "text",
        label: "Estado/Província*:",
        defaultValue: data?.address?.state,
        validations: "inputRequired",
        col: { xs: 4, md: 4, lg: 4 },
      },
      {
        name: "address",
        type: "text",
        label: "Logradouro*:",
        defaultValue: data?.address?.place,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "number",
        type: "text",
        label: "Número*:",
        defaultValue: data?.address?.number,
        validations: "inputRequired",
        col: { xs: 2, md: 2, lg: 2 },
      },
      {
        name: "district",
        type: "text",
        label: "Bairro*:",
        defaultValue: data?.address?.district,
        validations: "inputRequired",
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "complement",
        type: "text",
        label: "Complemento:",
        defaultValue: data?.address?.complement,
        col: { xs: 6, md: 6, lg: 6 },
      },
      {
        name: "email",
        type: "text",
        label: "E-mail*:",
        validations: "emailRequired",
        defaultValue: data?.email,
        col: { xs: 12, md: 12, lg: 12 },
      },
    );
    return [
      {
        groupName: "TOMADOR",
        groupLabel: "Tomador:",
        items: foreignItems,
      },
    ];
  }

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        toggleField,
        {
          name: "documentTypeEnum",
          type: "radio",
          defaultValue: data?.documentTypeEnum || "CPF",
          label: "Documento*",
          onChange: (e) => {
            setDocType(e);
          },
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "NONE", label: "Não Existe" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "documentNumber",
          type: "text",
          label: "CPF/CNPJ:",
          defaultValue: data?.documentNumber,
          placeholder:
            docType === "CPF" ? "000.000.000-00" : "SS.SSS.SSS/SSSS-00",
          mask: docType === "CPF" ? "000.000.000-00" : "SS.SSS.SSS/SSSS-00",
          validations: getDocValidation(docType),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          defaultValue: data?.municipalRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          defaultValue: data?.stateRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social/Nome*:",
          defaultValue: data?.socialReason,
          placeholder: "",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          mask: "00000-000",
          // validations: 'inputRequired',
          defaultValue: data?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
          onChange: async (val: string) => {
            const parseCep = val.replace("-", "");
            if (parseCep.length === 8) {
              const res: { data: ViaCepResponse } = await axios.get(
                `https://viacep.com.br/ws/${parseCep}/json/`,
              );

              setTimeout(() => {
                setAddressByCep(res.data);
              }, 500);
            }
          },
        },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          validations: "inputRequired",
          defaultValue: addressByCep?.logradouro || data?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          validations: "inputRequired",
          defaultValue: data?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          validations: "inputRequired",
          defaultValue: addressByCep?.bairro || data?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          defaultValue: data?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "text",
          label: "Estado:",
          defaultValue: data?.address?.state || addressByCep?.uf,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "text",
          label: "Cidade:",
          defaultValue: data?.address?.city || addressByCep?.localidade,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          // validations: 'emailRequired',
          defaultValue: data?.email,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "taxSubstitute",
          type: "radio",
          defaultValue: `${data?.taxSubstitute}`,
          label: "Substituto Tributária*",
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
      ],
    },
  ];
};
export const FieldsCNAES = (): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "CNAE:",
      items: [
        {
          name: "code",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "description",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },

        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "inputRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "inputRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "Activity",
      groupLabel: "Atividade Econômica:",
      items: [
        {
          name: "codeActivity",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "descriptionActivity",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "aliquot",
          type: "number",
          label: "Aliquota:",
          validations: "inputRequired",
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};

export const fieldsGrid = (
  setShow: any,
  setShowGrid: any,
  setSelected: any,
): ItemField[] => [
    {
      title: "Documento",
      key: "id",
      renderItem: (data: TakerModel) => data.documentNumber,
    },
    {
      title: "Nome",
      key: "createdAt",
      renderItem: (data: TakerModel) => data.socialReason,
    },
    {
      title: "",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.white}
            onClick={() => {
              setSelected(data);
              setShowGrid(false);
              setShow(true);
            }}
            title="Editar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={25}
              width={25}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];
